<template>
  <span :class="classes" @click="handleClick" tabindex="0">
    <span class="ui-tag__label"><slot></slot></span>
    <svg v-show="selected" class="close-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.5 2.8125L17.5 17.8125" stroke="white" stroke-width="2" />
      <path d="M17.5 2.8125L2.5 17.8125" stroke="white" stroke-width="2" />
    </svg>
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const emit = defineEmits(['select'])

const props = defineProps<{
  selected?: boolean
}>()

function handleClick(event) {
  emit('select')
  ;(event.currentTarget as HTMLElement)?.blur()
}

const classes = computed(() => {
  return {
    'ui-tag': true,
    'ui-tag--selected': props.selected
  }
})
</script>

<style scoped lang="scss">
@import '../styles/config';

.close-icon {
  display: none;
  font-size: 16px;
  font-weight: 400;
  line-height: 1;
}

.ui-tag__label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  line-height: 100%;
  transition: all 0.2s ease;
  height: 34px;
  padding-right: 12px;
}

.ui-tag {
  cursor: pointer;
  white-space: nowrap;

  display: flex;
  align-items: center;
  justify-content: center;
  height: 34px;
  padding: 12px;
  border-radius: 2px;
  border: 1px solid #DEDEDE;
  font-family: Barlow;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 26px;
  letter-spacing: .5px;
  background-color: #f4f4f4;
  color: #121318;

  @include media-breakpoint-up(md) {
    height: 44px;
  }

  &--selected {
    background-color: #0f0f14;
    color: #fff;
    border: none;

    > .close-icon {
      display: inline;
    }
  }

  &:focus {
    background-color: $black;
    border-color: $black;
  }
}
</style>
